<kt-loader [showLoader]="loading()">
  <form class="kt-form__section" (ngSubmit)="saveJobInformation()">

    <div class="kt-heading kt-heading--md kt-heading--space-sm"> {{'EMPLOYEE.JOB_INFORMATION' | translate}}
    </div>

    <!-- Body start -->
    <div class="kt-wizard-v2__form">
      <kt-formly [form]="_jobInformationForm" [fieldList]="formConstants" [options]="lookupOptions"
        [values]="{stress_profile: null}">
      </kt-formly>
    </div>
    <!-- Body end -->

    <!-- Footer start -->
    <div class="modal-footer"
      *ngxPermissionsOnly="isLoggedInUserProfile ? permissionConstant.EMPLOYEE.SAVE_PROFILE_JOB_INFORMATION :  permissionConstant.EMPLOYEE.SAVE_EMPLOYEE_JOB_INFORMATION">
      <kt-button [buttonConfig]="buttonConstants">
      </kt-button>
    </div>
    <!-- Footer end -->
  </form>
</kt-loader>